import {BrowserModule} from '@angular/platform-browser';
import {LOCALE_ID, NgModule} from '@angular/core';

import {AppComponent} from './app.component';
import {RouterModule} from '@angular/router';
import {APP_ROUTES} from './app.route';
import {HTTP_INTERCEPTORS, HttpClientModule} from '@angular/common/http';
import {AdminTokenInterceptorService} from './interceptors/admin-token-interceptor.service';
import { MenuTopComponent } from './components/menu-top/menu-top.component';
import {NotificationToastComponent} from './pages/notification-toast/notification-toast.component';
import {ToastModule} from '@syncfusion/ej2-angular-notifications';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {registerLocaleData} from '@angular/common';
import localeFr from '@angular/common/locales/fr';

registerLocaleData(localeFr);
@NgModule({
  declarations: [
    AppComponent,
    MenuTopComponent,
    NotificationToastComponent
  ],
  imports: [
    BrowserModule,
    RouterModule.forRoot(APP_ROUTES, {}),
    HttpClientModule,
    ToastModule,
    BrowserAnimationsModule
  ],
  providers: [
    /*************************** Outch attention aux interceptors   ***********************************/
    {provide: HTTP_INTERCEPTORS, useExisting: AdminTokenInterceptorService, multi: true},
    { provide: LOCALE_ID, useValue: 'fr-FR'},
  ],
  bootstrap: [AppComponent]
})
export class AppModule {
}
